
import {Component, Vue} from 'vue-property-decorator';
import {FormModel} from 'ant-design-vue';
import Api from '@/repository/api';
import {AuthStore} from '@/store/modules/Auth';
import PageTitle from '@/UI/components/common/PageTitle.vue';
import BaseDataForm from '@/UI/components/Helpers/BaseForm/BaseDataForm.vue';
@Component({components: {PageTitle, BaseDataForm}})
export default class CompanyProfile extends Vue {
  profile: any = null;
  form = {name: '', description: '', email: '', phone: '', website: ''};
  companies: Array<{id: number; name: string}> = [];
  selectedId: number | null = null;
  loading = true; saving = false; error = ''; saved = false;
  get systemAdmin(): boolean { return Boolean((Vue.auth.user() || {}).system_admin); }
  get readonly(): boolean { return this.saving || !this.profile || !this.profile.can_edit; }
  get dirty(): boolean { return Boolean(this.profile) && Object.keys(this.form).some(key => (this.form as any)[key] !== (this.profile[key] || '')); }
  get rules(): any {
    return {name: [{required: true, whitespace: true, message: this.$t('Введите название компании'), trigger: 'blur'}],
      email: [{type: 'email', message: this.$t('Введите корректную почту'), trigger: 'blur'}],
      website: [{pattern: /^https?:\/\/\S+$/i, message: this.$t('Укажите сайт с http:// или https://'), trigger: 'blur'}]};
  }
  reset(): void {
    Object.keys(this.form).forEach(key => { (this.form as any)[key] = this.profile[key] || ''; });
    this.error = ''; this.saved = false;
    this.$nextTick(() => { if (this.$refs.companyForm) (this.$refs.companyForm as FormModel).clearValidate(Object.keys(this.form)); });
  }
  errorText(error: any): string {
    const body = error.response && error.response.data;
    return body && body.errors ? Object.values(body.errors).flat().join(' ') : (body && (body.response || body.message)) || String(this.$t('Не удалось выполнить запрос. Повторите попытку.'));
  }
  selectCompany(id: number): void { this.selectedId = id; this.loadProfile(); }
  async loadProfile(): Promise<void> {
    this.loading = true; this.error = ''; this.saved = false; this.profile = null;
    try {
      const response = await Api.get('/company/profile', {params: this.systemAdmin ? {company_id: this.selectedId} : {}});
      this.profile = response.data.data; this.reset();
    } catch (error) { this.error = this.errorText(error); } finally { this.loading = false; }
  }
  async save(): Promise<void> {
    if (this.readonly || !this.dirty) return;
    const valid = await new Promise<boolean>(resolve => (this.$refs.companyForm as FormModel).validate(resolve));
    if (!valid) return;
    this.saving = true; this.error = ''; this.saved = false;
    try {
      const response = await Api.post('/company/profile', {...this.form, ...(this.systemAdmin ? {company_id: this.selectedId} : {})}, {headers: {'Content-Type': 'application/json'}});
      this.profile = response.data.data; this.reset(); this.saved = true;
      this.companies.forEach(company => { if (company.id === this.profile.id) company.name = this.profile.name; });
      const user = {...Vue.auth.user()};
      user.companies = (user.companies || []).map((company: any) => company.id === this.profile.id ? {...company, name: this.profile.name} : company);
      Vue.auth.user(user); sessionStorage.setItem('userData', JSON.stringify(user)); await AuthStore.fetchManual();
      window.dispatchEvent(new Event('pult-subscription-changed'));
    } catch (error) {
      this.error = this.errorText(error);
      if (error.response && error.response.status === 423) this.profile.can_edit = false;
    } finally { this.saving = false; }
  }
  async created(): Promise<void> {
    if (!this.systemAdmin) { await this.loadProfile(); return; }
    try { this.companies = (await Api.get('/company/get')).data.data; }
    catch (error) { this.error = this.errorText(error); } finally { this.loading = false; }
  }
}
